/**
 * Agentes IA registrados — modelos seleccionables del chat de clientes (F3 Inc 3).
 *
 * El selector de modelo lista las instancias de `AARPIA.ia.agente-ia.registrado` en estado
 * `activo` (ruta canónica; la versión la reescribe api.ts contra el catálogo vivo §33.5).
 *
 * Filtra a modalidad `consumida_por_organismo` (el default del campo): son los agentes que el
 * chat PUEDE invocar como proveedor LLM (tienen api_key/config del proveedor). Los
 * `actuante_en_organismo` son IDENTIDADES de agentes que actúan en el organismo (p.ej. los
 * Claude Code del equipo) — no son backends de chat; ofrecerlos rompería el turno
 * (loadProviderFromAgenteCanonico no encontraría api_key real). No es lógica de negocio: deriva
 * la UI de un campo canónico legible (modalidad), igual que se filtra por estado.
 *
 * El listado va scopeado al CO de sesión (RLS); un set vacío = ese CO no tiene modelos propios,
 * NO ausencia global. Los campos sensibles (api_key, credenciales) llegan redactados del back.
 */
import { api } from './api'

export interface AgenteModelo {
  id: string
  nombre: string
  proveedor: string
  modelo: string
  avatar_url?: string
  slug?: string
}

interface InstanciaCanonica {
  id: string
  attributes?: { payload?: Record<string, unknown> }
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined)

/** Agentes IA `activo` + `consumida_por_organismo` del CO de sesión, listos para el selector. */
export async function listarAgentesActivos(token: string | null): Promise<AgenteModelo[]> {
  const r = await api.get<{ data?: InstanciaCanonica[] }>(
    '/canonico/ia/agente-ia/registrado/v2.1/instancias?estado=activo',
    token,
  )
  return (r.data || [])
    .map((row) => ({ id: row.id, p: row.attributes?.payload || {} }))
    // Solo modelos que el chat puede invocar como proveedor; el default del campo es consumida.
    .filter(({ p }) => ((str(p.modalidad) ?? 'consumida_por_organismo') === 'consumida_por_organismo'))
    .map(({ id, p }) => ({
      id,
      nombre: str(p.nombre) ?? 'Agente IA',
      proveedor: str(p.proveedor) ?? '',
      modelo: str(p.modelo) ?? '',
      avatar_url: str(p.avatar_url),
      slug: str(p.slug),
    }))
}
